<template>
  <section v-if="node">
    <div v-if="node.enabledPath">
      <b-field horizontal label="Enabled">
        <c-switch v-model="enabledData" />
      </b-field>
    </div>
    <div v-for="field in node.fields" :key="field.label">
      <fieldset v-if="field.fields">
        <legend class="label">{{ field.label }}</legend>
        <fields
          v-model="value"
          :node="field"
          :errors="errors"
        />
      </fieldset>
      <field
        v-else
        v-model="value"
        :errors="errors"
        :field="field"
      />
    </div>
  </section>
</template>

<script>
import objectPath from 'object-path'
import CSwitch from '@/lib/components/Switch'
import Field from './Field'

export default {
  name: 'fields',
  props: ['value', 'errors', 'node'],
  components: {
    CSwitch,
    Field,
  },
  computed: {
    enabledData: {
      get() {
        return objectPath.get(this.value, this.node.enabledPath)
      },
      set(value) {
        objectPath.set(this.value, this.node.enabledPath, value)
      },
    },
  },
}
</script>

<style>
fieldset {
  padding-right: 15px;
  margin-bottom: 10px;
  border-radius: 10px;
}
legend.label {
  margin-left: 10%;
  padding-right: 10px;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/Form/Fields.vue